// extracted by mini-css-extract-plugin
export default {"feelings":"feelings_feelings__NBNy1","feelingsRange":"feelings_feelingsRange__2PZnz","bottom":"feelings_bottom__JZtpr"};